import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'github-pull-request-result.label',
		defaultMessage: 'Pull request',
		description: 'GitHub pull request label',
	},
});
